import React from 'react';
import { Link } from 'gatsby';
import PointRight from '@/components/icons/point-right';
import { formatUrl } from '@/utils/url';
import { getTranslatableSlug } from '@/utils/translatable-slug';

function CategoryNavigationItem({ category }) {
	const translatedSlug = getTranslatableSlug(category, category.lang);
	const categoryName = translatedSlug?.name || category.name;

	return (
		<li>
			<Link
				className="text-mariner flex justify-between items-center flex-row h-10 lg:border-t lg:border-grey-330"
				to={formatUrl(category.full_slug)}
			>
				{categoryName}
				<div className="hidden lg:block">
					<PointRight />
				</div>
			</Link>
		</li>
	);
}

export default CategoryNavigationItem;
